<template>
  <router-link to="/">
    <AkvelonLogoImage class="ml-5 akvelon-logo__image" />
  </router-link>
</template>

<script>
import AkvelonLogoImage from '@/assets/logo_ets.svg';

export default {
  components: {
    AkvelonLogoImage,
  },
};
</script>

<style>
.akvelon-logo__image {
    vertical-align: middle;
}
</style>
